// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

/** Names of implementations of @see {@link EncryptionKeyResolver} */
export enum EncryptionKeyResolverName {
  /** Name of @see {@link AzureKeyVaultEncryptionKeyResolver} implementation for key encryption keys in Azure Key vault*/
  AzureKeyVault = "AZURE_KEY_VAULT",
}
